/* tslint:disable */
/* eslint-disable */

/**
 * partnerDriverWeb driver-auth api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export * from './AppStore';
export * from './AppStoreVerificationResult';
export * from './AppleStoreAppVerificationResult';
export * from './AuthenticateResponse';
export * from './AuthenticateWithMagicLinkRequestBody';
export * from './BrandEnum';
export * from './ConfirmAuthenticationEmailVerificationResponse';
export * from './ConfirmAuthenticationRequest';
export * from './ConfirmAuthenticationResponseBase';
export * from './ConfirmAuthenticationResponseType';
export * from './ConfirmAuthenticationTokenResponse';
export * from './DeviceInformation';
export * from './EmailVerificationResponse';
export * from './GetAccessTokenResponse';
export * from './GoogleStoreAppVerificationResult';
export * from './HuaweiStoreAppVerificationResult';
export * from './RefreshTokenRequest';
export * from './RefreshTokenType';
export * from './ResendVerificationCodeRequest';
export * from './ResendVerificationCodeResponse';
export * from './StandardRequest';
export * from './StartAuthenticationBase';
export * from './StartAuthenticationResponse';
export * from './StoreAppVerificationResultBase';
export * from './TokenResponse';
export * from './V2ConfirmAuthentication200ResponseData';
export * from './VerificationCodeChannelClientOption';
